import staticPageApiFactory from '../../modules/static/staticPageApi';

/* Actions */
import {getStaticPageActionCreators} from '../actions/staticPageActions';

/* Utils */
import {
  generateDefaultAsyncSaga,
  generateDefaultAsyncWatcher,
} from '../core/reduxUtils';

function staticPageSagasFactory({storefrontApiClient}) {
  const staticPageApi = staticPageApiFactory(storefrontApiClient);

  const getStaticPageSagas = generateDefaultAsyncSaga(
    staticPageApi.getStaticPage,
    getStaticPageActionCreators,
    payload => [
      payload.staticPageId,
      payload.staticPageKey,
      payload.params,
    ],
  );

  const watchGetStaticPages = generateDefaultAsyncWatcher(
    'GET_STATIC_PAGE_INFO',
    getStaticPageSagas
  );

  const staticPageSagas = [
    watchGetStaticPages(),
  ];

  return staticPageSagas;
}

export default staticPageSagasFactory;







